module.exports = __webpack_public_path__ + "de0e577317e2e7cfd0beabbbab37cfac.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/medias/images/people.png
// module id = 878
// module chunks = 3